import { useCallback } from "react";

export const useGenerateJS = () => {
  const generateJS = useCallback((elements) => {
    let js = "";

    elements.forEach((el) => {
      const classNameForJs = `${
        el.classname ? el.classname : `element-${el.id}`
      }`;
      if (el.type === "DroppableButton" || el.type === "DroppableImage") {
        js += `
            document.querySelector('.${classNameForJs}').addEventListener('click', function() {
              ${
                el.redirectTo
                  ? `
              // Redirection logic
              window.location.href = '${el.redirectTo}.html'; // Replace with the actual URL or path to the target page
              `
                  : `
              // Default click action
              // console.log('Button ${classNameForJs} clicked');
              `
              }
            });
            `;
      } else if (el.type === "DroppableOutput") {
        js += `
            function updateOutput() {
            const numberInput = document.getElementById('${el.for}');
            const outputElement = document.getElementById('${el.Id_For_html}');
            outputElement.value = numberInput.value;  // Set the output element value
            outputElement.innerText = numberInput.value || 'Result';
        }
            `;
      }
    });
    return js.trim();
  }, []);

  return { generateJS };
};
